import IframedContent from '@ulta/core/components/IframedContent/IframedContent';

export default IframedContent;
